import { audio } from '@/audio/AudioService';
import { useT } from '@/i18n/useI18n';

/**
 * Shared "return to home" control. A clearly tappable pill (≥40px touch target,
 * cyan-accented chevron) replacing the old low-contrast "← BACK" text that was
 * hard to see and easy to miss on phones.
 */
export function BackButton({
  onClick,
  label,
}: {
  onClick: () => void;
  label?: string;
}) {
  const t = useT();
  return (
    <button
      onClick={() => {
        audio.play('ui.tap');
        onClick();
      }}
      aria-label={t('common.back_home')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        height: 40,
        padding: '0 16px 0 8px',
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid var(--hairline)',
        borderRadius: 999,
        color: 'var(--ink)',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <span
        style={{
          width: 26,
          height: 26,
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(34,211,238,0.16)',
          color: 'var(--c-cyan)',
          fontSize: 16,
          lineHeight: 1,
        }}
      >
        ←
      </span>
      <span style={{ fontFamily: 'var(--f-display)', fontSize: 11, letterSpacing: '0.06em' }}>
        {label ?? t('common.home')}
      </span>
    </button>
  );
}
